import React from 'react';
import { Icon } from 'js/components/common/Icon';
import style from './index.scss';

export default function Tabs({ tabs, activeTab, className: listClsName = '' }) {
    const tabsWidth = { width: `${100 / tabs.length}%` };

    return <ul className={`${style.tabs} ${listClsName}`}>
        {
            tabs.map(({ name, title, onClick, className = '', classNames = {} }, index) => {
                const activeTabStyle = [name, index].includes(activeTab)
                    ? `${style.active} ${classNames.active || ''}`
                    : '';

                return (
                    <li key={index}
                        style={tabsWidth}
                        className={`${style.tab} ${className} ${classNames.tab || ''} ${activeTabStyle}`}
                        onClick={onClick.bind(this, name != null ? name : index)}>
                        {classNames.icon && <Icon className={classNames.icon} />}
                        {title}
                    </li>
                );
            })
        }
    </ul>;
}
